module.exports = __webpack_public_path__ + "img/APP上架流程.6db6bc30.png";